<template>
  <div class="register">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step title="填写账号信息"></el-step>
      <el-step title="填写单位信息"></el-step>
      <el-step title="选择注册系统"></el-step>
      <el-step title="注册完成"></el-step>
    </el-steps>
    <div class="stepBox">
      <!-- 步骤一 -->
      <step1-form v-show="step1" @goToStep1="step1Data"></step1-form>
      <!-- 步骤2 -->
      <step2-form v-if="step2" @goToStep3="step2Data" @goBackStep1="goBackStep2Data"></step2-form>
      <!-- 步骤三 -->
      <step3-form v-if="step3" @goToStep4="step3Data" @goBackStep2="goBackStep3Data"></step3-form>
      <!-- 步骤四 -->
      <step4-form v-show="step4"></step4-form>
    </div>
  </div>
</template>

<script>
import step1Form from './components/Step1';
import step2Form from './components/Step2';
import step3Form from './components/Step3';
import step4Form from './components/Step4';

export default {
  components: {
    step1Form,
    step2Form,
    step3Form,
    step4Form
  },
  data() {
    return {
      active: 0,
      step1: true,
      step2: false,
      step3: false,
      step4: false
    };
  },
  methods: {
    /* 步骤一事件 */
    step1Data(step1Data) {
      this.active = step1Data;
      this.step1 = false;
      this.step2 = true;
    },
    /* 步骤二下一步事件 */
    step2Data(val1) {
      this.active = val1;
      this.step2 = false;
      this.step3 = true;
    },
    /* 步骤二上一步事件 */
    goBackStep2Data(val1) {
      this.active = val1;
      this.step2 = false;
      this.step1 = true;
    },
    /* 步骤三下一步事件 */
    step3Data(val1) {
      this.active = val1;
      this.step3 = false;
      this.step4 = true;
    },
    /* 步骤三上一步事件 */
    goBackStep3Data(val1) {
      this.active = val1;
      this.step2 = true;
      this.step3 = false;
    }
  }
};
</script>

<style lang="less" scoped>
.register {
  height: 100%;
  .stepBox {
    text-align: center;
  }
}
/deep/.el-steps--horizontal {
  width: 600px;
  margin: 34px auto 0;
}
/deep/.el-step__title.is-process {
  color: #409dff;
  font-weight: 400;
  line-height: 19px;
  font-size: 14px;
  margin-top: 9px;
}
/deep/.el-step__title.is-wait {
  color: #c0c4ce;
  font-weight: 400;
  line-height: 19px;
  font-size: 14px;
  margin-top: 9px;
}

/deep/.el-step__icon.is-text {
  width: 32px;
  height: 32px;
}
/deep/.el-step.is-horizontal .el-step__line {
  top: 15px;
  height: 1px;
  background-color: #dcdfe7;
  margin-top: 2px;
}
/deep/.el-step__head.is-success {
  color: #409dff;
  border-color: #409dff;
}
/deep/.el-step__title.is-success {
  color: #409dff;
}
/deep/.el-step__head.is-process {
  color: #409dff;
  border-color: #409dff;
}
</style>
